<template>
  <div>
    <header-portrate />
    <div>
      <bread-crumbs :items="items" />
      <TabsComp :tabs="tabs" />
      <v-row class="mainrow mt-2 mb-2" :style="`margin-inline-start:2px;direction:` + lang.dir + `;margin-top:-8px !important;`">
        <v-row class="mt-5">
          <v-col cols="12">
            <form autocomplete="off">
              <div class="searchTop general-maint-search">
                <div class="searchBar">
                  <div>
                    <div class="mobileFont">{{ lang.chose_from_list }} {{ lang.start_date }}</div>
                    <b-input-group>
                      <b-form-select class="inborder text-center" v-model="sd.day" :options="daysList" />
                      <b-form-select class="inborder text-center" v-model="sd.month" :options="monthsList" />
                      <b-form-select class="inborder text-center" v-model="sd.year" :options="yearsList" />
                    </b-input-group>
                  </div>
                  <div>
                    <div class="mobileFont">{{ lang.chose_from_list }} {{ lang.end_date }}</div>
                    <b-input-group>
                      <b-form-select class="inborder text-center" v-model="ed.day" :options="daysList" />
                      <b-form-select class="inborder text-center" v-model="ed.month" :options="monthsList" />
                      <b-form-select class="inborder text-center" v-model="ed.year" :options="yearsList" />
                    </b-input-group>
                  </div>
                  <div>
                    <div class="mobileFont">{{ lang.mobile }}</div>
                    <b-form-input class="inborder" v-model="mobile" />
                  </div>
                  <div>
                    <div class="mobileFont">{{ lang.cardid }}</div>
                    <b-form-input class="inborder" v-model="cardid" />
                  </div>
                  <div class="noInMobile">
                    <div class="mobileFont">{{ lang.chose_from_list }} {{ lang.customer_type }}</div>
                    <b-input-group>
                      <b-form-select class="selborder" v-model="customer_type" :options="customerTypes" />
                      <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                        <i class="fas fa-arrow-down"></i>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div class="SupStatus noInMobile">
                    <div class="mobileFont">{{ lang.chose_from_list }} {{ lang.superVisor }}</div>
                    <b-input-group>
                      <b-form-select class="selborder" v-model="superVisor" :options="super_visors" />
                      <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                        <i class="fas fa-arrow-down"></i>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div>
                    <div class="mobileFont">{{ lang.chose_from_list }} {{ lang.status }}</div>
                    <b-input-group>
                      <b-form-select class="selborder" v-model="status" :options="statuses" />
                      <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                        <i class="fas fa-arrow-down"></i>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div>
                    <div>&nbsp;</div>
                    <b-button variant="light" class="btnMobile search-btn" @click="getCurrentCards()">{{ lang.search }}</b-button>
                  </div>
                </div>
                <div class="general-maint-add">
                  <b-button
                    v-b-toggle.add_new_card
                    class="btn-sm btn addMobile"
                    @click="resetAllValues()"
                    id="multiply-button"
                  >
                    <div :class="`multiply-button-content-` + lang.lalgin">{{ text('add_general_maintenance_request') }}</div>
                  </b-button>
                </div>
              </div>
            </form>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" :style="`direction:${lang.dir};padding-inline-end:30px;`" v-if="cardStatus.length != 0">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="backBlack text-center" v-for="(item,index) in cardStatus" :key="index">{{ item[`name_${lang.langname}`] }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center" v-for="(item,index) in cardStatus" :key="index">{{ item.number }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>

          <v-col cols="12" :style="`padding-` + lang.lalgin + `:35px;direction:` + lang.dir + `;margin-top:-5px;`">
            <v-data-table
              :headers="headers"
              :items="tablerows"
              :search="search"
              :items-per-page="15"
              width="100%"
              id="MainTable"
              hide-default-footer
              hide-default-header
              fixed-header
            >
              <template slot="body.prepend">
                <tr>
                  <td
                    v-for="(iHead, indHead) in headers"
                    :key="indHead"
                    :class="iHead.class + ` text-center `"
                    style="border:1px solid #000 !important;"
                  >
                    {{ iHead.text }}
                  </td>
                </tr>
                <tr>
                  <td style="font-size:.1rem !important;background:#fff !important;border:none !important;" :colspan="headers.length">&#32;</td>
                </tr>
              </template>
              <template v-slot:item="row">
                <tr>
                  <td style="width:50px">{{ row.item.cardid }}</td>
                  <td nowrap class="text-center" :style="`width:80px;background:${row.item._customer_type_bgcolor} !important;color:${row.item._customer_type_color} !important;`">{{ row.item['_customer_type_' + lang.langname] }}</td>
                  <td nowrap>{{ row.item.superVisor }}</td>
                  <td nowrap>{{ row.item.customer }}</td>
                  <td>{{ row.item.mobile }}</td>
                  <td class="device-cell">
                    <div>{{ deviceDisplay(row.item) }}</div>
                    <small>{{ deviceDetails(row.item) }}</small>
                  </td>
                  <td nowrap>{{ safeDate(row.item.received_date) }}</td>
                  <td nowrap>{{ safeDate(row.item.delivery_date) }}</td>
                  <td v-if="$store.state.licenseType.showCardNums">{{ row.item.temp_expense }}</td>
                  <td v-if="$store.state.licenseType.showCardNums">{{ row.item.total }}</td>
                  <td v-if="$store.state.licenseType.showCardNums">{{ row.item.vat }}</td>
                  <td v-if="$store.state.licenseType.showCardNums">{{ row.item.ftotal }}</td>
                  <td v-if="$store.state.licenseType.showCardNums">{{ $RoundNums(parseFloat(row.item.temp_expense || 0) + parseFloat(row.item.ftotal || 0), 2) }}</td>
                  <td v-if="$store.state.licenseType.showCardNums">{{ row.item.paid }}</td>
                  <td v-if="$store.state.licenseType.showCardNums && row.item.remaining < 1">0</td>
                  <td v-if="$store.state.licenseType.showCardNums && row.item.remaining >= 1">{{ row.item.remaining }}</td>
                  <td style="text-align:center;background:red !important;color:#fff !important;" v-if="$store.state.licenseType.showCardNums && row.item.remaining != 0">{{ lang.card_not_paid }}</td>
                  <td style="text-align:center;background:green !important;color:#fff !important;" v-if="$store.state.licenseType.showCardNums && row.item.remaining == 0">{{ lang.card_paid }}</td>
                  <td :style="`text-align:center;background:` + row.item._invoiced_bg + ` !important;color:` + row.item._invoiced_color + ` !important;width:100px !important;font-weight:bolder !important`">{{ row.item['_invoiced_' + lang.langname] }}</td>
                  <td :style="`text-align:center;background:` + row.item._statusbg + ` !important;color:` + row.item._statuscolor + ` !important;width:100px !important;font-weight:bolder !important`">{{ row.item['_status_' + lang.langname] }}</td>
                  <td class="backBlue text-center view-cell">
                    <div v-b-toggle.popViewCard @click="ViewItem(row.item)">{{ lang.view }}</div>
                  </td>
                </tr>
              </template>
              <template slot="body.append">
                <tr>
                  <td style="font-size:.1rem !important;background:#fff !important;border:none !important;" :colspan="headers.length">&#32;</td>
                </tr>
                <tr class="black--text tfoot" v-if="$store.state.licenseType.showCardNums">
                  <td class="backEmpty" colspan="8"></td>
                  <td class="backBlack">{{ sumField('temp_expense') }}</td>
                  <td class="backBlack">{{ sumField('total') }}</td>
                  <td class="backBlack">{{ sumField('vat') }}</td>
                  <td class="backBlack">{{ sumField('ftotal') }}</td>
                  <td class="backBlack">{{ $RoundNums(parseFloat(sumField('ftotal')) + parseFloat(sumField('temp_expense')), 2) }}</td>
                  <td class="backBlack">{{ sumField('paid') }}</td>
                  <td class="backBlack">{{ sumField('remaining') }}</td>
                  <td class="backEmpty"></td>
                  <td class="backEmpty" colspan="3"></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" style="margin-bottom:25px;margin-top:-15px;">
            <v-container>
              <div class="text-center pt-2">
                <v-pagination v-model="page" value="10" :length="pageCount" color="#000" @input="getNext(page)" />
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-row>
      <addNewCard ref="createnew" maintenance-type="general" />
    </div>
    <popViewCard ref="viewCard" />
    <Footer />
    <div class="loadingPage" v-if="$store.state.showLoading">
      <v-progress-circular indeterminate color="blue" size="64" />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import addNewCard from '@/components/addNewCard.vue'
  import BreadCrumbs from '@/components/breadCrumbs.vue'
  import HeaderPortrate from '@/components/Header-Portrate.vue'
  import Footer from '@/components/Footer.vue'
  import popViewCard from '@/components/popViewCard.vue'
  import TabsComp from '@/components/tabsComp.vue'
  import { getVisibleTabsForRoute } from '@/menu/menuService'
  import {SnotifyPosition} from 'vue-snotify'

  export default Vue.extend({
    name: 'GeneralMaintenance',
    components: {
      addNewCard,
      BreadCrumbs,
      HeaderPortrate,
      Footer,
      popViewCard,
      TabsComp
    },
    data() {
      return {
        customer_type: 0,
        superVisor: 0,
        cpage: 0,
        status: 0,
        cardStatus: [],
        cardid: '',
        search: '',
        page: 1,
        pageCount: 0,
        mobile: '',
        tablerows: [],
        loading: false,
        sd: {
          day: 1,
          month: (new Date()).getMonth() + 1,
          year: (new Date()).getFullYear(),
        },
        ed: {
          day: (new Date()).getDate(),
          month: (new Date()).getMonth() + 1,
          year: (new Date()).getFullYear(),
        },
        allSupers: []
      }
    },
    created() {
      this.getStartDate();
      this.getCurrentCards();
    },
    methods: {
      text(key) {
        return this.lang[key] || key;
      },
      resetAllValues() {
        if(this.$refs.createnew) {
          this.$refs.createnew.resetValues();
          this.$refs.createnew.getInvSettings();
        }
      },
      getStartDate() {
        const d = new Date();
        this.sd.day = 1;
        this.sd.month = 1;
        this.sd.year = d.getFullYear();
      },
      safeDate(value) {
        return value ? String(value).substring(0, 10) : '-';
      },
      deviceInfo(item) {
        if(item && item.device_info && typeof item.device_info === 'object') {
          return item.device_info;
        }
        return {};
      },
      deviceDisplay(item) {
        const info = this.deviceInfo(item);
        const parts = [
          info.device_name || info.name,
          info.device_model || info.model,
          info.serial_number || info.serial
        ].filter(Boolean);
        return parts.length ? parts.join(' / ') : '-';
      },
      deviceDetails(item) {
        const info = this.deviceInfo(item);
        const parts = [
          info.accessories ? `${this.text('device_accessories')}: ${info.accessories}` : '',
          info.received_status ? `${this.text('device_received_status')}: ${info.received_status}` : ''
        ].filter(Boolean);
        return parts.join(' | ');
      },
      sumField(key) {
        let x = this.tablerows.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
        x = +x * 100;
        x = (Math.round(x) / 100);
        return x != 0 ? x : 0;
      },
      async ViewItem(item) {
        this.$refs.viewCard.cardid = item.cardid;
        await this.$refs.viewCard.getCard(item.cardid);
      },
      getNext(page) {
        this.cpage = parseInt(page) - 1;
        this.getCurrentCards();
      },
      getCurrentCards() {
        const ds = new Date(this.sdate);
        const de = new Date(this.edate);
        if(ds.getTime() > de.getTime()) {
          this.$snotify.error(this.lang.start_date_before_end_date, this.lang.alert, {
            timeout: 1000000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            position: SnotifyPosition.centerCenter,
            buttons: [
              {
                text: this.lang.close,
                action: (toast) => {
                  this.$snotify.remove(toast.id);
                }
              },
            ]
          });
          return false;
        }
        const post = new FormData();
        post.append('defBranch', localStorage.getItem('defBranch'));
        post.append('financeYear', localStorage.getItem('financeYear'));
        post.append('type', 'getNewCardslist');
        post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
        post.append('lang', this.$cookies.get(this.$store.state.LangCooki));
        post.append('data[datatype]', 'all');
        post.append('data[sdate]', this.sdate);
        post.append('data[edate]', this.edate);
        post.append('data[mobile]', this.mobile);
        post.append('data[cpage]', this.cpage);
        post.append('data[plate_number]', '');
        post.append('data[cardid]', this.cardid);
        post.append('data[status]', this.status);
        post.append('data[superVisor]', this.superVisor);
        post.append('data[customer_type]', this.customer_type);
        post.append('data[path_number]', '');
        post.append('data[maintenance_type]', 'general');
        this.$store.state.showLoading = true;
        this.loading = true;
        axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
          this.$store.state.showLoading = false;
          const res = response.data;
          this.allSupers = res.results.all_supers || [];
          this.tablerows = res.results.data || [];
          this.cardStatus = res.results.cards || [];
          this.loading = false;
          this.pageCount = parseInt(parseInt(res.results.allres || 0) / 15) + 1;
          this.page = parseInt(this.cpage) + 1;
        }).catch(() => {
          this.$store.state.showLoading = false;
          this.loading = false;
        });
      },
    },
    computed: {
      customerTypes: function() {
        return [
          {text: this.lang.nd_all, value: 0},
          {text: this.lang.individual_client, value: 1},
          {text: this.lang.company_client, value: 2},
          {text: this.lang.government_clinet, value: 3}
        ]
      },
      lang: function() {
        if(this.$cookies.get(this.$store.state.LangCooki) != null) {
          if(this.$cookies.get(this.$store.state.LangCooki) == 'en') {
            return this.$store.state.lang.en;
          } else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur') {
            return this.$store.state.lang.ur;
          } else {
            return this.$store.state.lang.ar;
          }
        } else if(this.$store.state.deflang == 'en') {
          return this.$store.state.lang.en;
        } else if(this.$store.state.deflang == 'ur') {
          return this.$store.state.lang.ur;
        }
        return this.$store.state.lang.ar;
      },
      statuses: function() {
        let t = [{text: this.lang.nd_all, value: 0}];
        Object.keys(this.cardStatus).forEach((key) => {
          t.push({
            text: this.cardStatus[`${key}`][`name_${this.lang.langname}`],
            value: key
          })
        })
        return t;
      },
      sdate: function() {
        return (new Date(this.sd.year, this.sd.month - 1, this.sd.day + 1)).toISOString().substring(0, 10);
      },
      edate: function() {
        return (new Date(this.ed.year, this.ed.month - 1, this.ed.day + 1)).toISOString().substring(0, 10);
      },
      yearsList: function() {
        const start_year = this.$store.state.licenseType.startYear || (new Date()).getFullYear();
        let t = [{text: this.lang.year, value: -1}];
        for(let i = 0; i < 100; i++) {
          if(parseInt(start_year) + i <= (new Date()).getFullYear()) {
            t.push({text: parseInt(start_year) + i, value: parseInt(start_year) + i})
          }
        }
        return t;
      },
      super_visors: function() {
        let t = [{text: this.lang.nd_all, value: 0}]
        for(let i = 0; i < this.allSupers.length; i++) {
          t.push({text: this.allSupers[i].full_name, value: this.allSupers[i].id})
        }
        return t;
      },
      daysList: function() {
        let t = [{text: this.lang.day, value: -1}];
        for(let i = 1; i <= 31; i++) {
          t.push({text: i, value: i})
        }
        return t;
      },
      monthsList: function() {
        let t = [{text: this.lang.chose_month, value: -1}];
        for(let i = 1; i <= 12; i++) {
          t.push({text: i, value: i})
        }
        return t;
      },
      headers: function() {
        let t = [
          {text: '#', align: 'center', filterable: false, value: 'cardid', sortable: false, class: 'pa-0 backBlack'},
          {text: this.lang.customer_type, align: 'center', filterable: false, value: 'customer', sortable: false, class: 'pa-0 backBlack'},
          {text: this.lang.superVisor, align: 'center', filterable: false, value: 'superVisor', sortable: false, class: 'pa-0 backBlack'},
          {text: this.lang.customer_name, align: 'center', filterable: false, value: 'customer', sortable: false, class: 'pa-0 backBlack'},
          {text: this.lang.mobile, align: 'center', filterable: false, value: 'mobile', sortable: false, class: 'pa-0 backBlack'},
          {text: this.text('device_info'), align: 'center', filterable: false, value: 'device_info', sortable: false, class: 'pa-0 backBlack'},
          {text: this.lang.received, align: 'center', filterable: false, value: 'sdate', sortable: false, class: 'pa-0 backBlack'},
          {text: this.lang.delivered, align: 'center', filterable: false, value: 'ddate', sortable: false, class: 'pa-0 backBlack'},
        ];
        if(this.$store.state.licenseType.showCardNums) {
          t.push({text: this.lang.temporary_expenses, align: 'center', filterable: false, value: 'parts', sortable: false, class: 'pa-0 backBlack'});
          t.push({text: this.lang.sales_total, align: 'center', filterable: false, value: 'total', sortable: false, class: 'pa-0 backBlack'});
          t.push({text: this.lang.sales_vat, align: 'center', filterable: false, value: 'vat', sortable: false, class: 'pa-0 backBlack'});
          t.push({text: this.lang.sales_ftotal, align: 'center', filterable: false, value: 'ftotal', sortable: false, class: 'pa-0 backBlack'});
          t.push({text: this.lang.all_total, align: 'center', filterable: false, value: 'ftotal', sortable: false, class: 'pa-0 backBlack'});
          t.push({text: this.lang.paid, align: 'center', filterable: false, value: 'paid', sortable: false, class: 'pa-0 backBlack'});
          t.push({text: this.lang.remain, align: 'center', filterable: false, value: 'remaining', sortable: false, class: 'pa-0 backBlack'});
          t.push({text: this.lang.card_paid_status, align: 'center', filterable: false, value: 'remaining', sortable: false, class: 'pa-0 backBlack'});
        }
        t.push({text: this.lang.isbilled, align: 'center', filterable: false, value: '', sortable: false, class: 'pad-0 backBlack'});
        t.push({text: this.lang.status, align: 'center', filterable: false, value: '', sortable: false, class: 'pad-0 backBlack'});
        t.push({text: this.lang.action, align: 'center', filterable: false, value: '', sortable: false, class: 'pad-0 backBlue'});
        return t;
      },
      items: function() {
        return {
          text: this.text('general_maintenance_request'),
          disabled: true,
          href: '/general-maintenance',
        }
      },
      tabs: function() {
        return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);
      }
    },
  })
</script>

<style>
.general-maint-search .searchBar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: flex-end;
}
.general-maint-search .searchBar > div {
  min-width: 110px;
}
.general-maint-search .inborder,
.general-maint-search .selborder {
  background: #efefef;
  border: 1px solid #777 !important;
  min-height: 32px;
}
.general-maint-search .b-input-group .custom-select {
  min-width: 55px;
}
.general-maint-add {
  margin-inline-end: 17px;
}
.general-maint-add .btn {
  margin-top: 9px;
  background: transparent;
  border: none !important;
  margin-left: -7px !important;
}
.general-maint-add [class^="multiply-button-content-"] {
  width: 170px;
  border: none !important;
}
.search-btn {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  background: blue !important;
  color: #fff !important;
  width: 75px;
}
.device-cell {
  min-width: 220px;
  white-space: normal;
}
.device-cell small {
  color: #555;
  display: block;
}
.view-cell {
  cursor: pointer;
  width: 85px;
  border: 1px solid #bbb !important;
}
</style>
